var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 32,
    viewBox: "0 0 21 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11435 1.89062H5.61719V9.15206H9.11435V1.89062Z",
    fill: "#130754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11435 16.8086H5.61719V24.07H9.11435V16.8086Z",
    fill: "#130754"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11435 11.2734H5.61719V14.6995H9.11435V11.2734Z",
    fill: "#FFCA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49716 7.86328H0V32.0008H3.49716V7.86328Z",
    fill: "#130754"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6163 22.8008H11.1191V30.0622H14.6163V22.8008Z",
    fill: "#130754"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6163 7.87109H11.1191V15.1325H14.6163V7.87109Z",
    fill: "#130754"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6163 17.2539H11.1191V20.6799H14.6163V17.2539Z",
    fill: "#E70488"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1163 0H16.6191V24.1375H20.1163V0Z",
    fill: "#130754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo16);
export default __webpack_public_path__ + "static/media/logo16.0c5050afc8bda03a603d99a65d1beb3a.svg";
export { ForwardRef as ReactComponent };